import React from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../i18n';

export default function LandingPage() {
  const { t, lang } = useI18n();
  const benefits = {
    zh: [
      { icon: '💬', title: '聊得来，比滑得快重要', text: '用兴趣、语言和生活方式找到真正愿意交流的人。' },
      { icon: '🌏', title: '跨语言，也能靠近', text: '内置多语言翻译，让不同国家的心意不被语言挡住。' },
      { icon: '🛡️', title: '先保护自己，再认识别人', text: '隐私设置、举报和拉黑工具，给每一次认识留出安全边界。' }
    ],
    en: [
      { icon: '💬', title: 'Compatibility beats swiping', text: 'Find people who truly want to talk, through interests, language and lifestyle.' },
      { icon: '🌏', title: 'Close the language gap', text: 'Built-in multi-language translation keeps feelings from being blocked by words.' },
      { icon: '🛡️', title: 'Protect yourself first', text: 'Privacy settings, reporting and blocking tools keep every connection safe.' }
    ],
    ja: [
      { icon: '💬', title: '相性が、スワイプより大事', text: '興味・言語・ライフスタイルで、本当に話したい人と出会えます。' },
      { icon: '🌏', title: '言葉の壁を越えて', text: '多言語翻訳機能で、国が違っても気持ちが伝わります。' },
      { icon: '🛡️', title: '自分を守ってから出会う', text: 'プライバシー設定・通報・ブロック機能で、安心して交流できます。' }
    ]
  };
  const list = benefits[lang] || benefits.zh;
  return (
    <main className="landing-page">
      <section className="landing-hero">
        <div className="landing-copy">
          <div className="landing-kicker">GLOBAL HEART · ADULT CONNECTION</div>
          <h1>{lang === 'en' ? <>For those serious about love, <span>find each other.</span></> : lang === 'ja' ? <>真剣に向き合う人と、<span>ちゃんと出会う。</span></> : <>让认真对待感情的人，<span>遇见彼此。</span></>}</h1>
          <p className="landing-lead">
            {lang === 'en' ? 'Cross language and distance to build real connections with people who listen. For adults seeking emotional companionship, serious dating and long-term relationships.' :
             lang === 'ja' ? '言葉や距離を越えて、心を開いて話せる相手を見つける。大人のための国際的な恋愛・心のつながりのコミュニティです。' :
             '跨越语言和距离，和愿意倾听的人建立真实连接。这里适合成年人寻找情感陪伴、认真恋爱和长期关系。'}
          </p>
          <div className="landing-actions">
            <Link className="btn btn-primary landing-cta" to="/register">{t('freeStart')}</Link>
            <Link className="landing-secondary" to="/login">{t('alreadyAccount')}</Link>
          </div>
          <div className="landing-trust">
            <span>🔒 {lang === 'en' ? 'Privacy First' : lang === 'ja' ? 'プライバシー重視' : '隐私优先'}</span>
            <span>🌐 {lang === 'en' ? 'Multi-language Chat' : lang === 'ja' ? '多言語チャット' : '多语言聊天'}</span>
            <span>🚫 {lang === 'en' ? 'Anti-harassment Tools' : lang === 'ja' ? '安心の通報機能' : '反骚扰工具'}</span>
          </div>
        </div>
        <div className="landing-card-stack">
          <div className="landing-profile profile-back">🌸<strong>{lang === 'en' ? 'Take your time. Be genuine.' : lang === 'ja' ? '焦らず、自然に。' : '慢慢了解，认真靠近'}</strong><small>Take your time. Be genuine.</small></div>
          <div className="landing-profile profile-front"><div className="profile-photo">💗</div><strong>{lang === 'en' ? 'Today, meet someone who gets you' : lang === 'ja' ? '今日、分かり合える人と。' : '今天，遇见懂你的人'}</strong><small>Global Heart</small><div className="profile-pills"><span>{lang === 'en' ? 'Genuine' : lang === 'ja' ? '誠実' : '真诚'}</span><span>{lang === 'en' ? 'Listening' : lang === 'ja' ? '思いやり' : '倾听'}</span><span>{lang === 'en' ? 'Respect' : lang === 'ja' ? '尊重' : '尊重'}</span></div></div>
        </div>
      </section>
      <section className="landing-section">
        <div className="section-eyebrow">WHY GLOBAL HEART</div>
        <h2>{lang === 'en' ? 'It starts with a good conversation' : lang === 'ja' ? '心地よい会話から始まる出会い' : '从一次舒服的对话开始'}</h2>
        <div className="landing-benefits">{list.map(b => <article className="landing-benefit" key={b.title}><div className="benefit-icon">{b.icon}</div><h3>{b.title}</h3><p>{b.text}</p></article>)}</div>
      </section>
      <section className="landing-safety">
        <div>
          <div className="section-eyebrow">A BETTER WAY TO CONNECT</div>
          <h2>{lang === 'en' ? 'Love can take time. Safety comes first.' : lang === 'ja' ? '関係はゆっくりでいい。安心は最初から。' : '关系可以慢一点，安全必须先一步。'}</h2>
          <p>{lang === 'en' ? 'We encourage clear communication, respect for boundaries and authentic conversation. We don\'t promise to change your life overnight — just to make it easier to meet people worth knowing.' : lang === 'ja' ? '無理に距離を縮める必要はありません。境界線と相互の尊重を大切にしながら、あなたのペースで交流できます。' : '我们鼓励清晰表达、尊重边界和真实交流。不承诺一夜改变人生，只帮你更容易遇到值得认识的人。'}</p>
        </div>
        <Link className="btn btn-secondary" to="/register">{lang === 'en' ? 'Create Free Profile' : lang === 'ja' ? 'プロフィールを作る' : '创建免费档案'}</Link>
      </section>
      <section className="landing-section landing-final">
        <h2>{lang === 'en' ? 'Your next connection starts with a hello.' : lang === 'ja' ? '次のつながりは、「こんにちは」から。' : '你的下一段连接，从一句你好开始。'}</h2>
        <p>{lang === 'en' ? 'Sign up free. Explore first, then decide how deep to go.' : lang === 'ja' ? '無料登録して、まずは世界の誰かと話してみませんか。' : '免费注册，先探索，再决定是否深入了解。'}</p>
        <Link className="btn btn-primary landing-cta" to="/register">{lang === 'en' ? 'Join Global Heart' : lang === 'ja' ? 'Global Heartを始める' : '加入 Global Heart'}</Link>
        <div className="landing-languages">中文 · English · 日本語 · Español · Français</div>
      </section>
    </main>
  );
}
